import { useState } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import AktionsAngebot from "@/components/landing/AktionsAngebot";
import Services from "@/components/landing/Services";
import Process from "@/components/landing/Process";
import Trust from "@/components/landing/Trust";
import Footer from "@/components/landing/Footer";
import BookingForm from "@/components/landing/BookingForm";

export default function Landing() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [promoOpen, setPromoOpen] = useState(false);
  const openBooking = () => setBookingOpen(true);
  const openPromo = () => setPromoOpen(true);
  return (
    <div className="min-h-screen bg-[#FAFAF5]">
      <Header onCta={openBooking} />
      <Hero onCta={openBooking} />
      <AktionsAngebot onCta={openPromo} />
      <Services onCta={openBooking} />
      <Process />
      <Trust />
      <section id="kontakt" className="bg-[#2C3E2D] text-white py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="text-xs font-medium text-[#95A97A] uppercase tracking-wider mb-3">
            Bereit für Ihr gepflegtes Grundstück?
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mb-6">
            Ein Anruf reicht.<br />Alles rund ums Haus – wir übernehmen.
          </h2>
          <p className="text-[#B8C1A9] mb-8 max-w-lg mx-auto">
            Erhalten Sie in wenigen Minuten Ihre Bestätigung für die kostenlose
            Erstbesichtigung – unverbindlich, persönlich und direkt bei Ihnen vor Ort.
          </p>
          <button
            onClick={openBooking}
            data-testid="footer-cta-btn"
            className="inline-flex items-center gap-2 bg-white text-[#2C3E2D] hover:bg-[#E8ECE1] px-8 py-3 rounded-full font-medium transition-all hover:scale-[1.02]"
          >
            Jetzt Termin sichern →
          </button>
        </div>
      </section>
      <Footer />
      <BookingForm open={bookingOpen} onOpenChange={setBookingOpen} />
      <BookingForm open={promoOpen} onOpenChange={setPromoOpen} promo />
    </div>
  );
}
